export enum SupportRequestStatuses {
  PendingInitialApproval = 1,
  InitialApprovalApproved = 2,
  PendingExceptionsCommitteeApproval = 3,
  PendingExecution = 4,
  PendingCompletion = 5,
  CompletionReturned = 6,
  Done = 7,
  Rejected = 8,
  Cancelled = 9,
  PaymentReturned = 10,
  DonePendingCompletion = 11,
  DoneCompletionReturned = 12,
  PendingSignatures = 13,
}
